module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e9ae6dc958d4dcf32971dc199d130aac.gif";